import styled from 'styled-components';

import { Text, TextArea } from '@gympass/yoga';
import { AlertTriangle } from '@gympass/yoga-icons';

import { Button } from '../../components/Button';

export const Container = styled.form`
  align-items: center;
  display: grid;
  gap: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  grid-template-rows: 1fr auto;
  height: ${({ theme }) => theme.yoga.sizes.containerHeight}px;
  justify-items: center;
  width: ${({ theme }) => theme.yoga.sizes.calendarEventContainerHeight}px;
`;

export const Body = styled.div``;

export const Title = styled(Text.H5)`
  width: ${({ theme }) => theme.yoga.fontSizes.contentWidth};
`;

export const Message = styled(Text.H5)`
  text-align: center;
  font-size: ${({ theme }) => theme.yoga.fontSizes.large}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.large}px;
  padding: ${({ theme }) => theme.yoga.spacing.zero}px
    ${({ theme }) => theme.yoga.sizes.messagePadding}px;
  width: ${({ theme }) => theme.yoga.fontSizes.contentWidth};
`;

export const ConfirmActions = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
`;

export const CancelButton = styled(props => <Button {...props} />)`
  background-color: ${({ theme }) => theme.yoga.colors.inputBackground};
  color: ${({ theme }) => theme.yoga.colors.primary};
  margin-right: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  &:hover {
    background-color: ${({ theme }) => theme.yoga.colors.text.primary};
    color: ${({ theme }) => theme.yoga.colors.inputBackground};
  }
`;

export const AcceptButton = styled(props => <Button {...props} />)`
  color: ${({ theme }) => theme.yoga.colors.inputBackground};
`;

export const Instructions = styled(Text.Small)`
  color: ${({ theme }) => theme.yoga.colors.textSecondary};
  margin-bottom: ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const Confirm = styled.div`
  align-items: center;
  display: grid;
  gap: ${({ theme }) => theme.yoga.spacing.xxxlarge}px;
  grid-auto-flow: column;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const Motive = styled(TextArea)`
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const StyledAlertTriangle = styled(AlertTriangle)`
  width: ${({ theme }) => theme.yoga.spacing.xxxlarge}px;
  height: ${({ theme }) => theme.yoga.spacing.xxxlarge}px;
  fill: ${({ theme }) => theme.yoga.colors.primary};
`;
